<template>
	<div style="width:90%"> 
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					
				
					<el-form-item label="伙伴名称" class='tiny' cleartable>
						
						
						
						
						<el-input style="width: 200px;" v-model="searchInfo.partnerName" placeholder="请输入伙伴名称"></el-input>
					</el-form-item>
					
					<el-form-item label="联系人" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.linkUser" placeholder="请输入联系人"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入联系电话"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.email" placeholder="请输入邮箱"></el-input>
					</el-form-item>
					<el-form-item label="所属区域:" label-width="80px">
						<el-select clearable filterable v-model="searchInfo.provinceId" placeholder="请选择省" @change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.cityId" placeholder="请选择市" @change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.areaId" placeholder="请选择区" @change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="-1">全部</el-option>
							<el-option key="0" label="过期" value="0">过期</el-option>
							<el-option key="1" label="正常" value="1">正常</el-option>
							<el-option key="2" label="停用" value="2">停用</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dialogVisibleFun();title='新增'">新增伙伴
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			
		
			<el-table-column prop="partnerName" label="伙伴名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="partnerLogo" label="LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.partnerLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="linkUser" label="联系人" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="phone" label="联系电话" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="email" label="邮箱" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="address" label="地址" align="center" :show-overflow-tooltip="true"  width="270px">
				<template slot-scope="scope">
					{{scope.row.province+scope.row.city+scope.row.area+scope.row.address}}
				</template>
			</el-table-column>
			
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color:#E6A23C;font-weight: bold;">过期</p>
					<p v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</p>
					<p v-if="scope.row.status==2" style="color:#F56C6C;font-weight: bold;">停用</p>
				</template>
			</el-table-column>
			<el-table-column prop="partnerIntro" label="伙伴简介" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
				<el-button size="small"	@click="findDetail(scope.row.partnerIntro)">查看</el-button>
				</template>
			</el-table-column>
			

			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center" width="200">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id);title='编辑'">编辑</el-button>
					
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					
					　　　　
				</template>
				　　</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 店铺审核 -->
		
		
		<!-- 禁用 或 启用 -->
		<el-dialog style="float:rigin" :title="formStatus.status ? '禁 用':'启 用'" :visible.sync="editStatusDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div class="app-container">
				<el-form ref="form" :model="formStatus" :rules="mainFormRules" size="medium">
					<el-form-item label="禁用说明:" v-show="formStatus.status">
						<el-col :span="18">
							<el-input v-model="formStatus.refuseReason" placeholder="请输入禁用说明" />
						</el-col>
					</el-form-item>
					
					<div style="text-align: center;">
						<el-button :loading="toStatusLoading" type="primary" @click="toStatus()">{{formStatus.status ? '禁 用':'启 用'}}
						</el-button>
						<el-button @click="editStatusDialogVisible = false">取 消</el-button>
					</div>
				</el-form>
			</div>
		</el-dialog>


		<!-- 编辑商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" :title="title" :visible.sync="dialogVisible" width="60%" >
			<div class="app-container" style="text-align: center;padding-right:80px;">
				<el-form size="medium" label-width="120px">
					

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="伙伴名称" >
							<el-input type="text" v-model="storeInfo.partnerName" placeholder="请输入伙伴名称" />
						</el-form-item>
						
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="Logo" >
							<!-- 图片上传 -->
							<el-upload  :class="{hide: partnerLogo.length>0}" :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="partnerLogo" :show-file-list="true" :limit="1" list-type="picture-card" :on-remove="handleRemoveTwo"
								:before-upload="beforeAvatarUpload" :on-success="onSuccessTwo">
								<i class="el-icon-plus"></i>
							</el-upload>
							
							</el-upload>
						</el-form-item>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: flex-start;width: 600px;" >
						<el-form-item label="联系人">
							<el-input type="text" v-model="storeInfo.linkUser" style="width: 120px;" placeholder="请输入联系人" />
						</el-form-item>
						<el-form-item label="联系电话">
							<el-input type="text" v-model="storeInfo.phone" style="width: 140px;" placeholder="请输入联系电话" />
						</el-form-item>
						<el-form-item label="邮箱">
							<el-input type="text" v-model="storeInfo.email" style="width: 170px;" placeholder="请输入邮箱" />
						</el-form-item>
						
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="省/市/区" style="width:800px;">
							<el-select clearable filterable v-model="storeInfo.provinceId" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeInfo.cityId" placeholder="请选择市"
								 @change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="regionId" placeholder="请选择区"
								 @change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="详细地址" style="width:790px;">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
					</div>
					<div style="display: flex;">
						<el-form-item label="状态" class='tiny' cleartable style="width: 260px;">
							<el-select v-model="storeInfo.status" placeholder="请选择">
								<el-option key="0" label="过期" value="0">过期</el-option>
						
								<el-option key="1" label="正常" :value="1">正常</el-option>
								<el-option key="2" label="停用" :value="2">停用</el-option>
							</el-select>
						</el-form-item>
						<el-form-item  label="排序级别">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" style="width: 150px;"
								v-model="storeInfo.orderIndex" placeholder="请输入数字(降序)" />
						</el-form-item>
					</div>
					
					
				
					<div>
					
						<el-form-item label="伙伴介绍">
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="storeInfo.partnerIntro" style="height: 400px;" ref="myQuillEditor" class="editer" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;margin-top: 120px;">
				<el-button v-if="title=='新增'" type="primary" @click="sure" :loading="sureLoading">添 加</el-button>
				<el-button v-if="title=='编辑'" type="primary" @click="edit" :loading="editLoading">修 改</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog><!-- 查看店铺各种照片 -->
		<el-dialog title="照片" :visible.sync="showContentDialog" width="50%" :closeOnClickModal="false">
			<div>
				<div>
					<img style="width: 100%;" :src="storeInfo.storeLogo" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdFace" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdBack" />
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogImg" :closeOnClickModal="false" width="700px">
			<div style="text-align: center;">
				<img width="600px" style="width:600px;height:auto" :src="popupImageUrl">
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div style="max-height:700px;overflow-y:scroll; overflow-x:hidden;">
				<div class="detailImg"  v-html="detail"></div>
				
			</div>
			<div style="text-align: center;margin-top:50px">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('store');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				httpUrl: urls,
				loading: false,
				storeList: [{}], //列表
				dialogVisible: false, // 审核
				editDialogVisible: false, // 编辑
				showContentDialog: false, //查看证件照片
				editStatusDialogVisible: false,//禁用或启用
				formStatus:{},
				accountList: [],
				username: '',
				regionId:'',
				storeInfo: {
					userId: "",
					isHot: "",
					storeLogo: "",
					storeName: "",
					storeIntro: "",
					type: "",
					linkUser: "",
					phone: "",
					legalIdNumber: "",
					legalIdFace: "",
					legalIdBack: "",
					provinceId: "",
					cityId: "",
					regionId: "",
					province: "",
					city: "",
					area: "",
					address: "",
					storeType:'', 
				},
				store_logo: [], //店铺logo
				provinceList: {},
				cityList: {},
				districtList: {},
				storeId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					isHot: '',
					checkState: '',
					status: '',
					storeType: ''

				},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				dialogVisibleDetails:false, //logo查看弹窗
				storeLoading: false,
				auditInfo: {}, //店铺审核信息
				auditType: '', //店铺审核类型

				partnerLogo:[], //店铺营业执照
				fileList: [], //证件照片
				fileListTwo: [], //店铺照片

				dialogImg:false,
				popupImageUrl:'',

				BusinessCategory:[], //经营类别

				storeGoodsFlag: false,
				poupName: '1',
				poupStoreName: '',
				poupStoreID: 0,

				storeTypeFlage: 0,
				findGoodInfo: {},
				storeGoodsList: [],
				goodLoadingOne: false,

				findGoodInfoTwo: {},
				storeGoodsListTwo: [],
				goodLoadingTwo: true,
				pageGood: {
					pageNum: 1,
					pageSize: 10,

					pageNumTwo: 1,
					pageSizeTwo: 10
				},
				

				detail: '',
				images: [],
				detailType: 0,

				stoId: '', //用户ID

				sureLoading: false,
				editLoading: false,


				storeZCFlage: false,
				storeRecordList: {},
				storeRecordLoading: false,
				pageStoreRecord: {
					pageNum: 1,
					pageSize: 10,
				},
				storeZCInfo: {},
				searchStoreZCInfo: {
					changeType: null,
					timer: [],
					source: ''
				},
				typeList: [],

				checkLoading: false, //审核
				toStatusLoading: false, //禁用或启用
			};
		},

		methods: {
			tchange(e){
				console.log(e);
			},
			toStoreZC(row){  //资产变动记录
				this.storeZCInfo = row;
				this.storeZCFlage = true;
				this.storeRecordList = {};
				this.searchStoreZCInfo =  {
					changeType: null
				};
				this.pageStoreRecord.pageNum = 1;
				this.pageStoreRecord.pageSize = 10;
				this.getStoreRecordList();
				this.getRecordTypeList();
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---',res )
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
			emptyStoreZC() {
				this.searchStoreZCInfo = {}
			},
			searchStoreZCClick() {
				this.pageStoreRecord.pageNum = 1;
				this.getStoreRecordList();
			},
			pageChangeStoreZC(data) {
				this.pageStoreRecord.pageNum = data
				this.getStoreRecordList()
			},
			handleSizeChangeStoreZC(val) {
				this.pageStoreRecord.pageSize = val
				this.getStoreRecordList()
			},
			getStoreRecordList(){
				let data = {
					storeId: this.storeZCInfo.id,

					pageNum: this.pageStoreRecord.pageNum,
					pageSize: this.pageStoreRecord.pageSize,

					startTime: this.searchStoreZCInfo.timer ? this.searchStoreZCInfo.timer[0] : "",
                    endTime:  this.searchStoreZCInfo.timer ? this.searchStoreZCInfo.timer[1] : "" ,
					changeType: this.searchStoreZCInfo.changeType,
					source: this.searchStoreZCInfo.source,
				}
				this.$api.storeAssetChangesList(data).then((res) => {
					if (res.state == 'success') {
						this.storeRecordList = res.data
					} else {
						this.$message.error(res.message)
					}
					this.storeRecordLoading = false
				})
			},
			
			searchGood(){ //条件查询商品
				this.pageGood.pageNum = 1
				this.getStoreGoodsList();
			},
			emptyOne(){
				this.findGoodInfo = {}
			},
			pageChangeOne(val){
				this.pageGood.pageNum = val
				this.getStoreGoodsList()
			},
			handleSizeChangeOne(val){
				this.pageGood.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.goodLoadingOne = true
				this.findGoodInfo.orderType = 3;
				this.findGoodInfo.storeId = this.poupStoreID;
				this.findGoodInfo.pageNum = this.pageGood.pageNum;
				this.findGoodInfo.pageSize = this.pageGood.pageSize;
				this.$api.getStoreGoodsList({...this.findGoodInfo,goodsType:1}).then((res) => { //商品列表
					if (res.state == 'success') {
						this.storeGoodsList = res.data
						this.goodLoadingOne = false
					}
				})
			},

			searchGoodTwo(){ //条件查询商品
				this.pageGood.pageNumTwo = 1
				this.getStoreGoodsListTwo();
			},
			emptyTwo(){
				this.findGoodInfoTwo = {}
			},
			pageChangeTwo(val){
				this.pageGood.pageNumTwo = val
				this.getStoreGoodsListTwo()
			},
			handleSizeChangeTwo(val){
				this.pageGood.pageSizeTwo = val
				this.getStoreGoodsListTwo()
			},
			getStoreGoodsListTwo() {
				this.goodLoadingTwo = true
				this.findGoodInfoTwo.storeId = this.poupStoreID;
				this.findGoodInfoTwo.pageNum = this.pageGood.pageNumTwo;
				this.findGoodInfoTwo.pageSize = this.pageGood.pageNumTwo;
				this.$api.ssGoodsList(this.findGoodInfoTwo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.storeGoodsListTwo = res.data
						this.goodLoadingTwo = false
					}
				})
			},

			getBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					isShow: true
				}
				this.$api.BusinessCategoryList(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.BusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			clickImg(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
			//上传店铺logo
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.store_logo.push({
					url: response.message
				})
			},
			handleRemove(file, fileList) {
				this.store_logo = [];
			},

			onSuccess1(response, file) {
				// console.log(response)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList.remove(file.url);
			},
			onSuccess1Two(response, file) {
				// console.log(response)
				this.fileListTwo.push({
					"url": response.message
				})
			},
			handleRemove1Two(file, fileList) {
				if (file.response) {
					this.fileListTwo.remove(file.response.message);
				}
				this.fileListTwo.remove(file);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handleRemoveTwo(file, fileList) {
				this.partnerLogo = [];
			},
			handlePictureCardPreview(file) {
				// this.dialogImageUrl = file.url;
				// this.dialogVisibleImg = true;

				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			

			findDetail(string) {
				this.dialogVisibleDetails = true;
					this.detail = string;

				
			},

			toExamine(id,num){ // 查询店铺详细信息
				//审核驳回弹窗打开
				this.form.refuseReason = ""; //驳回原因
					
				this.auditType = num; //审核类型
				this.auditInfo = {}; //审核数据信息

				this.storeId = id
				this.$api.getStoreId(this.storeId).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.auditInfo = res.data;
						// console.log('审核信息1---',this.auditInfo )
						// this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						// this.auditInfo.storeImages = res.data.storeImages.split(',')
						if(res.data.bankLicenceImage){ //证件照片
							this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						}
						if(res.data.storeImages){  //店铺照片
							this.auditInfo.storeImages = res.data.storeImages.split(',')
						}
						// console.log('审核信息2---',this.auditInfo )
						this.editDialogVisible = true;
					}
				})
			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						username: e
					}
					this.$api.getUserNameList(data).then((res) => {
						if (res.state == 'success') {
							if (res.data && res.data.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data
							} else {
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}

				
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreList()
			},
			showFile(info) {
				this.showContentDialog = true
				this.storeInfo.storeLogo = info.storeLogo
				this.storeInfo.legalIdFace = info.legalIdFace
				this.storeInfo.legalIdBack = info.legalIdBack
			},
			//店铺提交审核
			editStoreInfoCheck(id, checkState) {
				this.checkLoading = true;
				if (checkState == 2) {
					//通过驳回
					var data = {
						id: this.storeId,
						checkState: checkState,
						refuseReason: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						checkState: checkState
					}
				}
				this.$api.editStoreInfoCheck(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreList()
					} else {
						this.$message.error(res.message);
					}
					this.checkLoading = false;
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.province = obj.name
				this.storeInfo.cityId = ""
				this.storeInfo.regionId = ""
				this.regionId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.city = obj.name
				this.storeInfo.regionId = ""
				this.regionId = ""
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				this.storeInfo.areaId = e;
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.area = obj.name
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}
				this.storeId = ""
				this.regionId = '';
				this.store_logo = [];
				this.partnerLogo = [];
				this.fileList = [];
				this.fileListTwo = [];

				if (id) {
					this.storeId = id
					this.$api.findByIdpartner(this.storeId).then((res) => {
						if (res.state == 'success') {
							// console.log('更具ID查询---',res.data)
							this.storeInfo = res.data;
							
							if(this.storeInfo.partnerLogo){
								this.partnerLogo.push({
									url: this.storeInfo.partnerLogo
								})
							}else{
								this.partnerLogo = []
							}

							console.log(this.partnerLogo,123);

							if (this.storeInfo.provinceId) {
								this.$api.getAreasFive(this.storeInfo.provinceId).then((res) => {
									if (res.state == 'success') {
										this.cityList = res.data
									}
								})
							}
							if (this.storeInfo.cityId) {
								this.$api.getAreasFive(this.storeInfo.cityId).then((res) => {
									if (res.state == 'success') {
										this.districtList = res.data
									}
								})
							}
							this.regionId = res.data.regionId;

							
						}
					})
				} 
				this.dialogVisible = true;
			},
			//新增店铺
			sure() {
				this.storeInfo.regionId = this.regionId;
				if(this.partnerLogo.length == 1){
					this.storeInfo.partnerLogo = this.partnerLogo[0].url; //营业执照
				}
				this.sureLoading = true;
				this.$api.addPartner(this.storeInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});

						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})

			},
			//编辑
			edit() {				
				let data={
					id: this.storeId,
				
					partnerName: this.storeInfo.partnerName,
					partnerIntro:this.storeInfo.partnerIntro,
					linkUser: this.storeInfo.linkUser,
					phone: this.storeInfo.phone,
					status:this.storeInfo.status,
					orderIndex:this.storeInfo.orderIndex,
					regionId: this.storeInfo.areaId || this.regionId,
					area: this.storeInfo.area,
					cityId: this.storeInfo.cityId,
					city: this.storeInfo.city,
					provinceId: this.storeInfo.provinceId,
					province: this.storeInfo.province,
					address: this.storeInfo.address,
					emall:this.storeInfo.emall,
					partnerLogo: '',
				
				}
				if(this.partnerLogo.length == 1){
					data.partnerLogo = this.partnerLogo[0].url; //营业执照
				}
			
				
				

				this.editLoading = true;
				// console.log('编辑数据---', data)
				this.$api.editPartner(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.editLoading = false;
				})
			},
			editStatusShow(store){
				this.editStatusDialogVisible=true;
				this.formStatus=store;
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该伙伴, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delpartner(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//禁用启用
			toStatus() {
				this.toStatusLoading = true;
				let str;
				this.$api.editStoreBlockUpOrStartUsing(this.formStatus).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreList();
						this.editStatusDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.toStatusLoading = false;
				})
				// if (this.formStatus == 0) {
				// 	str = "此操作将启用该店铺账号, 是否继续?"
				// } else {
				// 	str = "此操作将禁用该店铺账号, 是否继续?"
				// }
				// this.$confirm(str, '提示', {
				// 	confirmButtonText: '确定',
          		// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	console.log('点击了确定')
				// 	that.$api.editStoreBlockUpOrStartUsing(that.formStatus).then((res) => {
				// 		if (res.state == 'success') {
				// 			that.$message({
				// 				message: res.message,
				// 				type: 'success'
				// 			});
				// 			that.getStoreList();
				// 			that.editStatusDialogVisible = false;
				// 		} else {
				// 			that.$message.error(res.message);
				// 		}
				// 	})
				// }).catch(() => {
				// 	this.$message({
				// 		type: 'info',
				// 		message: '已取消'
				// 	});
				// });
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
			
			
				this.$api.partner({...this.searchInfo,
						...this.page
			}).then((res) => { //管理列表
					console.log('店铺管理列表:', res.data.list[0]);
					if (res.state == 'success') {
						this.storeList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},

			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.data
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.data
				})
			},

			// 上传店铺logo点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传店铺logo上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			
			// 上传营业执照点击文件触发
			handlePreviewTwo(file) {
				// console.log(file)
			},
			// 上传营业执照 上传图片前，筛选
			beforeAvatarUploadTwo(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				let imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//上传营业执照
			onSuccessTwo(response, file, fileList) {
				// console.log(response);
				this.partnerLogo.push({
					url : response.message
				});
			},

			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				console.log(editor);
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('登录人信息---', res.data )
						// supplierId(有值就是供应商)
						this.stoId = res.data.storeId; // storeId：0(平台)   
					}
				})
				
			}
		},
		created() {
			this.getStoreList();
			//查询省
			this.$api.getAreasFive(0).then((res) => {
				if (res.state == 'success') {
					this.provinceList = res.data
				}
			})
			this.getBusinessCategoryList();

			this.logInUserInfo()
		}

	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>